export function SiteTaskIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            width={18}
            height={20}
            viewBox="0 0 512 512"
        >
            <g>
                <path
                    d="M64 448h384v32H64zm48-64h48V224h-48zm96 0h48V128h-48zm96 0h48V288h-48zm96 0h48V160h-48z"
                    fill="#000000"
                    opacity={1}
                    data-original="#000000"
                    className=""
                />
                <path
                    d="M96 192l72-72 88 88 120-120 40 40-160 160-88-88-32 32z"
                    fill="#000000"
                    opacity={1}
                    data-original="#000000"
                    className=""
                />
            </g>
        </svg>
    );
}